<template>
  <school-lookup @selectSchool="goToSchool"></school-lookup>
</template>

<script>
import SchoolLookup from "./school-lookup.vue";
export default {
  components: { SchoolLookup },
  methods: {
    goToSchool(schoolId) {
      this.$router.push({ name: "SchoolForm", params: { schoolId: schoolId } });
    },
  },
};
</script>
